import type { IBlobError } from "@/shared/common/types";

export const roundNumber = (num: number, fractionalPartLength = 2): number => {
  const [wholePart, fractionalPart = "0"] = `${num}`.split(".");

  return Number(`${wholePart}.${fractionalPart.slice(0, fractionalPartLength)}`);
};

export const downloadFileFromUrl = (url: string, fileName: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};

export const blobToText = async (error: IBlobError) => {
  return await error?.data?.text();
};
